<script>
import dropdown from "@/components/form components/dropdown";
import changePasswordModal from "@/components/changePasswordModal";
export default {
  name: "settings",
  components: {
    dropdown,
    changePasswordModal
  },
  data: function() {
    return {
      defaultDuration: null,
      defaultDecriment: null,
      defaultCurrency: null,
      defaultDurationCache: null,
      defaultDecrimentCache: null,
      defaultCurrencyCache: null,
    };
  },
  methods: {
    async saveChanges() {
      var self = this;

    self.defaultDurationCache = self.defaultDuration;
    self.defaultDecrimentCache = self.defaultDecriment;
    self.defaultCurrencyCache = self.defaultCurrency;

      var success = await this.$store.dispatch("postRequest", { controller: "user", method: "UserConfiguration", parameters: {
        "Duration": self.defaultDuration,
        "Decriment": self.defaultDecriment,
        "Currency": self.defaultCurrency,
      }});
      self.$store.commit("setSettingsSaveStatus", false);
    },
    canSave(){
      var self = this;
      return self.defaultDuration != self.defaultDurationCache || self.defaultDecriment != self.defaultDecrimentCache || self.defaultCurrency != self.defaultCurrencyCache ;
    },
    onChangePasswordClick: function(){
      this.$store.commit("toggleChangePasswordModal", true);
    }
  },
  computed: {
    canSaveComp: function(){
        var self = this;
        return self.defaultDuration != self.defaultDurationCache || self.defaultDecriment != self.defaultDecrimentCache || self.defaultCurrency != self.defaultCurrencyCache;
    },
        userRole: function() {
      return this.$store.state.role;
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
  },
  async mounted(){
    var configuration = await this.$store.dispatch("getRequest", { controller: "user", method: "UserConfiguration" });
    this.defaultDuration = configuration.duration || 10;
    this.defaultDecriment = configuration.decriment || 50;
    this.defaultCurrency = configuration.currency || "GBP";

    this.defaultDurationCache = configuration.duration || 10;
    this.defaultDecrimentCache = configuration.decriment || 50;
    this.defaultCurrencyCache = configuration.currency || "GBP";
    var self = this;
  },
  watch: {
    defaultDuration: function(val){
      var self = this;
      self.$store.commit("setSettingsSaveStatus", self.canSave());
    },
    defaultDecriment: function(val){
      var self = this;
      self.$store.commit("setSettingsSaveStatus", self.canSave());
    },
    defaultCurrency: function(val){
      var self = this;
      self.$store.commit("setSettingsSaveStatus", self.canSave());
    },
  }
};
</script>

<template>
<div style="padding-left:15px;padding-right:15px;">
  <div class="row">
    <div class="col-md-6 padding-right" v-if="!isOwner">
      <div style="padding:5px">
      <div class="row">
        <h4>Auction Settings</h4>
      </div>
      <div class="row">
          <div class="input-wrapper">
            <label>Default Duration (minutes)</label>
            <input v-model.number="defaultDuration" type="number" class="form-control" style="width:100%" placeholder="Default Duration (in minutes)"></input>
          </div>
      </div>
      <div class="row">
          <div class="input-wrapper">
            <dropdown label="Default Currency" v-model="defaultCurrency" :inputValue="defaultCurrency" dataSourceController="lookup" dataSourceMethod="GetCurrencies"></dropdown>
          </div>
      </div>
      <div class="row">
          <div class="input-wrapper">
            <label>Minimum Decriment ({{defaultCurrency}})</label>
            <input v-model.number="defaultDecriment" type="number" class="form-control" style="width:100%" :placeholder="`Decriment value (${defaultCurrency})`" ></input>
          </div>
      </div>
      <div class="row">
         <button type="button"  :disabled="!canSaveComp" style="width:100%" class="btn btn-light" v-on:click="saveChanges()">Save Changes</button>
      </div>
      </div>

      </div>

    
    
    
    

    <div class="col-md-6" :class="[isOwner ? 'offset-md-3' : '']" >
      <div style="padding:5px;">
      <div class="row">
        <h4>Account Settings</h4>
      </div>
      <div class="row">
         <button type="button" style="width:100%" class="btn btn-light" v-on:click="onChangePasswordClick()">Change Password</button>
      </div>
      </div>

    </div>
  </div>
  <change-password-modal></change-password-modal>
</div>

</template>
<style scoped>
.input-wrapper{
  margin-bottom:0.5rem;
  width:100%;
}
</style>
